var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 44C68 51.5 72.12 58.03 78.22 61.45C84.14 64.77 88 70.84 88 77.63V78.18C88 83.6 83.6 88 78.18 88H77.37C72.98 88 69.23 85.05 67.92 80.86C64.88 71.09 55.77 64 45 64C44.66 64 44.33 64.01 44 64.03C43.67 64.02 43.34 64 43 64C32.23 64 23.12 71.09 20.08 80.86C18.78 85.05 15.02 88 10.63 88H9.82C4.4 88 0 83.6 0 78.18V77.63C0 70.84 3.85 64.78 9.78 61.45C15.88 58.03 20 51.49 20 44C20 36.51 15.88 29.97 9.78 26.55C3.85 23.22 0 17.16 0 10.37V9.82C0 4.4 4.4 0 9.82 0H11.63C16.02 0 19.77 2.95 21.08 7.14C24.12 16.91 33.23 24 44 24C54.77 24 63.88 16.91 66.92 7.14C68.22 2.95 71.98 0 76.37 0H78.18C83.6 0 88 4.4 88 9.82V10.37C88 17.16 84.15 23.22 78.22 26.55C72.12 29.97 68 36.51 68 44Z",
    fill: "#3F0C46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon07);
export default __webpack_public_path__ + "static/media/icon_07.71def2522d0bbce8c64ad2d47067990b.svg";
export { ForwardRef as ReactComponent };